import React, { useState, useEffect, useRef } from "react";
import GridBuilder from "../../UIBuilderEngine/GridBuilder";
import {
  ButtonFilled,
  ButtonOutlined,
} from "../../reusableComponent/UIButtons";
import { Form, message, Spin, Switch, Checkbox, Steps, Select } from "antd";
import UITable from "../../reusableComponent/UITable/UITable";
import { RightOutlined } from "@ant-design/icons";
import StyledClientWrapper from "./style";
import StepsProgress from "../../reusableComponent/StepProgress/StepsProgress";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { setGetAllClientData } from "../../Redux/systemSlice";
import { useDispatch, useSelector } from "react-redux";
import emailjs from "@emailjs/browser";
import { useFetchData } from "../../ReactQuery/Fetch";
import {locationList} from "../../Common/Location"
const AddNewClient = ({ selectedRow, setSelectedRow }) => {
  const [form] = Form.useForm();
  const formRef = useRef(null);
  const [emailList, setEmailList] = useState([]);
  const getUserInfo = localStorage.getItem("users");
  const userInfo = getUserInfo;
  const userDetails = JSON.parse(userInfo)
  console.log("userDetails---->", userDetails)
  const CheckboxOption = ["HR", "Pay"];
  const token = localStorage.getItem("token")
  const getAllClientData = useSelector(
    (state) => state.systemTracking.getAllClientData
  );

  const EMAIL_REGEX = /^[a-zA-Z0-9.%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;

  // const getEmailList = async () => {
  //   const response = await axios.get(
  //     "https://nz9pn78wqi.execute-api.ap-south-1.amazonaws.com/Prod/add-users/email-list"
  //   );

  //   setEmailList(response?.data?.response?.response);
  // };

  const validateEmployeeId = (rule, value) => {
    if (value && emailList?.includes(value)) {
      return Promise.reject("User ID already exist");
    }
    return Promise.resolve();
  };

  const dataSource = [
    {
      key: 1,
      clientName: "Dashboard - Mine",
      name: "dashboard",
      access: selectedRow?.dashboard,
      planType: "Basic",
    },
    {
      key: 2,
      clientName: "Check in and check out through Biometrics",
      name: "checkinout_biometric",
      access: selectedRow?.checkinout_biometric,
      planType: "Basic",
    },
    {
      key: 3,
      clientName: "Leave application through portal",
      name: "leaveapplication_portal",
      access: selectedRow?.leaveapplication_portal,
      planType: "Basic",
    },
    {
      key: 4,
      clientName: "Calendar view - Mine",
      name: "calender_view",
      access: selectedRow?.calender_view,
      planType: "Basic",
    },
    {
      key: 5,
      clientName: "Calendar view - Team",
      name: "calender_view",
      access: selectedRow?.calender_view,
      planType: "Basic",
    },
    {
      key: 6,
      clientName: "Calendar view - All",
      name: "calender_view",
      access: selectedRow?.calender_view,
      planType: "Basic",
    },
    {
      key: 7,
      clientName: "Standard Reporting (Daily Attendance & Leave Report)",
      name: "standard_reporting",
      access: selectedRow?.calender_view,
      planType: "Basic",
    },
    {
      key: 8,
      clientName: "Exception Reports - Late check-in ",
      name: "exception_report",
      access: selectedRow?.exception_report,
      planType: "Basic",
    },
    {
      key: 9,
      clientName: "Exception Reports - Early Check out",
      name: "exception_report",
      access: selectedRow?.exception_report,
      planType: "Basic",
    },
    {
      key: 10,
      clientName: "Exception Reports - Absent Report",
      name: "exception_report",
      access: selectedRow?.exception_report,
      planType: "Basic",
    },
    {
      key: 11,
      clientName: "Support",
      name: "support",
      access: selectedRow?.support,
      planType: "Basic",
    },
    {
      key: 12,
      clientName: "HR Resources - Policies",
      name: "hr_resources",
      access: selectedRow?.hr_resources,
      planType: "Lite",
    },
    {
      key: 13,
      clientName: "HR Resources - People",
      name: "hr_resources",
      access: selectedRow?.hr_resources,
      planType: "Lite",
    },
    {
      key: 14,
      clientName: "Manage",
      name: "manage",
      access: selectedRow?.manage,
      planType: "Lite",
    },
    {
      key: 15,
      clientName: "Shift Management",
      name: "shift_management",
      access: selectedRow?.shift_management,
      planType: "Lite",
    },

    {
      key: 16,
      clientName: "Document Management",
      name: "document_management",

      access: selectedRow?.document_management,
      planType: "Lite",
    },
    {
      key: 17,
      clientName: "Dashboard - My Team",
      name: "my_teams",

      access: selectedRow?.my_teams,
      planType: "Lite",
    },
    {
      key: 18,
      clientName: "Monthly Attendance Reports",
      name: "monthly_attandance_report",

      access: selectedRow?.monthly_attandance_report,
      planType: "Lite",
    },
    {
      key: 19,
      clientName: "Asset Management",
      name: "asset_management",

      access: selectedRow?.asset_management,
      planType: "Lite",
    },
    {
      key: 20,
      clientName: "Mobile App",
      name: "mobile_app",

      access: selectedRow?.mobile_app,
      planType: "Lite",
    },
    {
      key: 21,
      clientName: "Recruitment Management",
      name: "recruitment_manaement",

      access: selectedRow?.recruitment_manaement,
      planType: "Lite",
    },
    {
      key: 22,
      clientName: "Automated Onboarding",
      name: "automated_onboarding",

      access: selectedRow?.automated_onboarding,
      planType: "Lite",
    },
    {
      key: 23,
      clientName: "Appraisal Management",
      name: "apprisal_management",

      access: selectedRow?.apprisal_management,
      planType: "Lite",
    },
    {
      key: 24,
      clientName: "Dashboard - HR",
      name: "dashboard_hr",
      access: selectedRow?.dashboard_hr,
      planType: "Pro",
    },
    {
      key: 25,
      clientName: "Performance Management",
      name: "performance_management",

      access: selectedRow?.performance_management,
      planType: "Pro",
    },
    {
      key: 26,
      clientName: "Travel/ Expense Approvals Management",
      name: "travel_expenses",

      access: selectedRow?.travel_expenses,
      planType: "Pro",
    },

    {
      key: 27,
      clientName: "Expense Reimbursement",
      name: "expenses_reimbursment",

      access: selectedRow?.expenses_reimbursment,
      planType: "Pro",
    },
    {
      key: 28,
      clientName: "Disciplinary Management",
      name: "disciplinary_management",

      access: selectedRow?.disciplinary_management,
      planType: "Pro",
    },
    {
      key: 29,
      clientName: "Incident Reporting",
      name: "incident_reporting",
      access: selectedRow?.incident_reporting,
      planType: "Pro",
    },
    {
      key: 30,
      clientName: "Simba AI",
      name: "simba_ai",
      access: selectedRow?.simba_ai,
      planType: "Pro",
    },
    {
      key: 31,
      clientName: "Org Chart",
      name: "org_chart",
      access: selectedRow?.org_chart,
      planType: "Pro",
    },
    {
      key: 32,
      clientName: "Activity Log",
      name: "activity_log",
      access: selectedRow?.activity_log,
      planType: "Pro",
    },
    {
      key: 33,
      clientName: "Report Preferences",
      name: "report_preference",
      access: selectedRow?.report_preference,
      planType: "Pro",
    },
    {
      key: 34,
      clientName: "Integration with existing Payroll system",
      name: "integrateex_payroll",
      access: selectedRow?.integrateex_payroll,
      planType: "Pro",
    },
    {
      key: 35,
      clientName: "Payroll",
      name: "payroll",
      access: selectedRow?.payroll,
      planType: "Pro",
    },
  ];

  const [countries, setCountries] = useState([]);
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);
  const [ispermission, setIsPermission] = useState(false);
  const [clientPermissionData, setClientPermissionData] = useState(dataSource);
  const [menuList, setMenuList] = useState([]);
  const [step, setStep] = useState(0);
  const [data, setData] = useState({});
  const allLocationData = useSelector((state) => state.systemTracking.getAllLocationData);

  const loactionData = Object.keys(allLocationData)?.map((key) => {
    return{
      label: key,
      value: key
    }
  })

  const tabledata = [
    {
      id: 1,
      featurename: "Dashboard(Mine, My Team, HR)",
      // pricing: "-",
      subscription: "Basic | Lite | Pro",
    },
    {
      id: 2,
      featurename: "Check in and Check out through Biometrics",
      // pricing: "-",
      subscription: "Lite | Pro",
    },
    {
      id: 3,
      featurename: "Leave application through portal",
      // pricing: "-",
      subscription: "Lite",
    },
  ];

  const columns = [
    {
      title: "Feature name",
      dataIndex: "featurename",
      key: "featurename",
      width: "25%",
    },
    // {
    //   title: "Pricing",
    //   dataIndex: "pricing",
    //   key: "pricing",
    //   width: "25%",
    // },
    // {
    //   title: "Available in Subscription Model",
    //   dataIndex: "subscription",
    //   key: "subscription",
    //   width: "25%",
    // },
    {
      title: "Access",
      dataIndex: "action",
      key: "action",
      width: "25%",
      render: () => {
        return <Switch size="small" />;
      },
    },
  ];

  const handleSubmitForm = async (val) => {
    try {
      setStep(1)
    } catch (error) {
      console.error("Validation failed:", error);
      return; // Stop execution if validation fails
    }
  };

  const handleFormChange = (e) => {
    setData({
      ...data,
      [e.target.name]: e.target.value,
    });
  };

  const handleSelectChange = (value, name) => {

    if(name === "system"){
      let defaultProductData = "";

      if (value.includes("hr") && value.includes("pay")) {
          defaultProductData = "1"; // If both are present, set to "1"
      } else if (value.includes("hr")) {
          defaultProductData = "1"; // If only HR is present, set to "1"
      } else if (value.includes("pay")) {
          defaultProductData = "2"; // If only Pay is present, set to "2"
      }
      setData({
        ...data,
        [name]: value,
        defaultproduct: defaultProductData
      });
    }else {
      setData({
        ...data,
        [name]: value,
      });
    }
  };

  const handleClickCancel = () => {
    navigate("/client");
  };
  const handleClickPrev = () => {
    if (step === 0) {
      navigate("/client");
    } else {
      setStep(step - 1);
    }
  };

  const SubcriptionPlanData = [
    { value: "basic", label: "Basic" },
    { value: "lite", label: "Lite" },
    { value: "pro", label: "Pro" },
  ];

  useEffect(() => {
    const fetchCountries = async () => {
      try {
        const response = await axios.get("https://restcountries.com/v3.1/all");

        const countryOptions = response.data.map((country) => ({
          label: country.name.common, // Display name
          value: country.name.common, // Country code as value
        }));
        setCountries(countryOptions);
      } catch (error) {
        console.error("Error fetching country data:", error);
      }
    };

    fetchCountries();
  }, []);

  const SystemList = ["HR", "Pay"];

  const handleClickNext = async () => {
    await form.validateFields();
    setStep(1);
  };

  const SystemOption = [
    { label: "Hr", value: "hr" },
    { label: "Pay", value: "pay" },
  ];

  const addNewClientForm = {
    totalpages: 1,
    pages: [
      {
        modalView: false,
        colSpan: [],
        fields: [
          [
            {
              id: 1,
              label: "Company Name:",
              type: "text",
              name: "company_name",
              Placeholder: "",
              maxLength: 50,
              onKeyDown: /^[a-zA-Z\s]+$/,
              validationRules: [
                { required: true, message: "Company name is required" },
                {
                  min: 0,
                  max: 50,
                  // message: "Company name must be within 50 alphabetic characters",
                },
                // {
                //   pattern: /^[a-zA-Z\s]*$/,
                //   // message: "Company name cannot contain numbers or special characters",
                // },
              ],
            },
            {
              id: 2,
              label: "Client Name:",
              type: "text",
              name: "client_name",
              Placeholder: "",
              maxLength: 50,
              onKeyDown: /^[a-zA-Z\s]+$/,
              validationRules: [
                { required: true, message: "Client name is required" },
                {
                  min: 0,
                  max: 50,
                  // message: "Client name must be 3-50 alphabetic characters",
                },
                {
                  pattern: /^[a-zA-Z\s]*$/,
                  // message: "Client name cannot contain numbers or special characters",
                },
              ],
              onInput: (e) => {
                e.target.value = e.target.value.replace(/[0-9]/g, "");
              },
            },
          ],
          [
            {
              id: 3,
              label: "Location:",
              type: "select",
              name: "location",
              //options: countries,
              options: locationList,
              Placeholder: "Select Location",
              validationRules: [
                { required: true, message: "Location is required" },
              ],
            },
            {
              id: 4,
              label: "Employee Count / Company Size:",
              type: "number",
              name: "employee_count",
              maxLength: 4,
              Placeholder: "",
              onKeyDown: /^[0-9]$/,
              validationRules: [
                {
                  required: true,
                  message: "Employee Count is required",
                },
                {
                  pattern: /^[0-9]+$/,
                  message: "Employee Count must be a number",
                },
                {
                  validator: (_, value) => {
                    if (value && parseInt(value, 10) > 1000) {
                      return Promise.reject("Employee Count cannot exceed 1000");
                    }
                    return Promise.resolve();
                  },
                },
              ],
              // CountNumber: digitCount,
            },
          ],
          [
            {
              id: 5,
              label: "Contact Person:",
              type: "text",
              name: "contact_person",
              onKeyDown: /^[a-zA-Z\s]+$/,
              Placeholder: "",
              maxLength: 30,
              validationRules: [
                {
                  required: true,
                  message: "Contact Person is required",
                },
                {
                  min: 0,
                  max: 30,
                  // message: "Contact Person must be 3-50 alphabetic characters",
                },
                {
                  pattern: /^[a-zA-Z\s]*$/,
                  // message: "Contact Person cannot contain numbers or special characters",
                },
              ],
            },
            {
              id: 6,
              label: "Contact Number:",
              type: "phone",
              name: "contact_number",
              maxLength: 20,
              Placeholder: "",
              validationRules: [
                { required: true, message: "Contact Number is required" },
                {
                  min: 0,
                  max: 20,
                },
                {
                  pattern: /^\+?[0-9]{10,20}$/,
                  message: " ",
                },
              ],
              validateTrigger: "onBlur",
            },
          ],
          [
            {
              id: 7,
              label: "Email ID:",
              type: "email",
              name: "email_id",
              Placeholder: "",
              validationRules: [
                {
                  required: true,
                  pattern: EMAIL_REGEX,
                  message: "Email ID is required",
                },
                { validator: validateEmployeeId },
              ],
            },
            {
              id: 11,
              label: "Status:",
              type: "select",
              name: "status",
              options: [
                { label: "Active", value: "active" },
                { label: "Inactive", value: "inactive" },
              ],
              Placeholder: "Select Status",
              validationRules: [
                { required: true, message: "Status is required" },
              ],
            },

            // {
            //   id: 8,
            //   label: "Password:",
            //   type: "password",
            //   name: "password",
            //   Placeholder: "",
            // }
          ],
          [
            {
              id: 9,
              label: "Subscription Plan:",
              type: "select",
              name: "subscription_plan",
              options: SubcriptionPlanData,
              Placeholder: "Select Subscription Plan ",
              validationRules: [
                { required: true, message: "Subscription Plan is required" },
              ],
            },
            {
              id: 10,
              label: "Subscription Frequency:",
              type: "select",
              name: "supscription_frequency",

              options: [
                { label: "Bi-annually", value: "biannually" },
                { label: "Quaterly", value: "quaterly" },
                { label: "Monthly", value: "monthly" },
                { label: "Yearly", value: "yearly" },
              ],
              Placeholder: "Select Subscription Frequency",
              validationRules: [
                {
                  required: true,
                  message: "Subscription Frequency is required",
                },
              ],
            },
          ],
          [
            {
              id: 9,
              label: "Subscription Start Date:",
              type: "date",
              name: "subscription_start_date",
              // name: "",
              Placeholder: "",
              // maxLength: 50,
              // onKeyDown: /^[a-zA-Z\s]+$/,
              validationRules: [
                {
                  required: true,
                  message: "Subscription Start Date is required",
                },
              ],
            },

            {
              id: 10,
              label: "Subscriber Count:",
              type: "text",
              name: "subscriber_count",
              Placeholder: "",
              onKeyDown: /^[0-9]$/,
            },
          ],
          [
            {
              id: 8,
              label: "Amount ($):",
              type: "text",
              name: "amount",
              maxLength: 10,
              onKeyDown: /^[0-9]$/,
              Placeholder: "",
              validationRules: [
                { required: true, message: "Amount is required" },
                {
                  min: 0,
                  max: 10,
                },
                {
                  pattern: /^[0-9]{1,10}$/,
                  message:
                    "Amount must be a number",
                },
              ],
            },
            {
              id: 12,
              label: "Discount(offer%):",
              type: "text",
              name: "discount",
              Placeholder: " ",
              onKeyDown: /^[0-9]$/, // Allow only digits
            },
          ],
          [
            // {
            //   id: 13,
            //   label: "Password:",
            //   type: "password",
            //   name: "password",
            //   validationRules: [
            //     {
            //       required: true,
            //       message: "Password is required.",
            //     },
            //     {
            //       validator: (_, value) => {
            //         if (!value || value.trim()?.length === 0) {
            //           return Promise.reject("");
            //         } else if (value?.length < 8 || value?.length > 15) {
            //           return Promise.reject(
            //             "Password should be min 8 to max 15 characters."
            //           );
            //         } else {
            //           return Promise.resolve();
            //         }
            //       },
            //     },
            //   ],
            //   Placeholder: "Password",
            //   maxLength: 15,
            //   // onKeyDown: /^[a-zA-Z\s]+$/,
            // },
            {
              id: 14,
              label: "System Purchasing:",
              type: "select",
              name: "system",
              multipleSelect: "multiple",
              options: [
                { label: "HR", value: "hr" },
                { label: "Pay", value: "pay" },
              ],
              Placeholder: "Select System",
              validationRules: [
                { required: true, message: "System is required" },
              ],
            },
            {
              id: 15,
              label: "Default Product:",
              type: "select",
              disabled: Array.isArray(data?.system) && data.system.includes("hr") && data.system.includes("pay") ? false : true,
              name: "defaultproduct",
              // options: [
              //   { label: "TymeplusHR", value: "1" },
              //   { label: "Tymeplus pay", value: "2" },
              // ],
              options: (() => {
                if (!Array.isArray(data?.system)) return [];
            
                if (data.system.includes("hr") && data.system.includes("pay")) {
                  return [
                    { label: "TymeplusHR", value: "1" },
                    { label: "Tymeplus Pay", value: "2" },
                  ];
                } else if (data.system.includes("hr")) {
                  return [{ label: "TymeplusHR", value: "1" }];
                } else if (data.system.includes("pay")) {
                  return [{ label: "Tymeplus Pay", value: "2" }];
                }
            
                return [];
              })(),
              Placeholder: "Select default product",
              validationRules: [
                { required: true, message: "Default product is required" },
              ],
            },
          ],
          // [

          //   {}
          // ],
          // [
          //   {
          //     id: 13,
          //     label: "System:",
          //     type: "checkboxgroup",
          //     name: "system",
          //     options: CheckboxOption,
          //     Placeholder: "System Status",
          //     validationRules: [
          //       { required: true, message: "System is required" },
          //     ],
          //   },
          // ],
          // [
          //   {
          //     label: "HR",
          //     type: "checkbox",
          //     id: 21,
          //   },
          // ],
          [
            {
              id: 15,
              label: "Cancel",
              type: "buttongroup",
              position: "end",
              textColor: "white",
              buttons: [
                {
                  label: "Cancel",
                  disabled: false,
                  // loading: loader,
                  event: "cancel",
                  onClick: () => {
                    handleClickPrev();
                  },
                },
                {
                  label: "Next",
                  // loading: loader,
                  section: "banks",
                  event: "submit",
                  // onClick: () => {
                  //   handleSubmitForm();
                  // }
                },
                // Add more buttons as needed
              ],
            },
          ],
        ],
      },
    ],
  };

  const stepdata = [
    { id: 1, title: "Basic" },
    { id: 2, title: "Features" },
  ];

  const getClientId = (name) => {
    const uniqueId = Math.random().toString(36).substr(2, 5);
    let clientId =
      name[0].toUpperCase() + name[1].toUpperCase() + uniqueId.toUpperCase();
    return clientId;
  };
  console.log("select---->", data)
  const getMenuList = async () => {
    try {
      const API =
        "https://peo32t8k2i.execute-api.ap-south-1.amazonaws.com/dev/user/menulist";
      const response = await axios.get(API);
      setMenuList(response?.data?.response?.menulistjson);
    } catch (error) {}
  };
  useEffect(() => {
    getMenuList();
    // getEmailList();
  }, []);

  const handlesubmit = async (clientId) => {
    try {
      const userauthregisterurl =
        "https://peo32t8k2i.execute-api.ap-south-1.amazonaws.com/dev/user/register";

      const updatedValues = CheckboxOption?.reduce((acc, option) => {
        acc[option] = data?.system?.includes(option) || false;
        return acc;
      }, {});

      const payload = {
        companyName: data?.company_name,
        country: "",
        domain: "",
        email: data?.email_id,
        employeeCount: data?.employee_count,
        firstName: data?.client_name,
        interval: "",
        lastName: "",
        monthlyCost: 0,
        password: data?.password,
        paymentType: "free",
        products: {
          tymeplusHrStatus: data?.system?.includes("hr") ? true : false,
          tymeplusPayStatus: data?.system?.includes("pay") ? true : false,
        },
        productList: "",
        defaultProduct: data?.defaultproduct,
        totalCost: 0,
        type: "company",
        subscription_plan: data?.subscription_plan,
        subscription_start_date: data?.subscription_start_date,
        phoneNumber: data?.contact_number,
        usermenuList: menuList,
        clientId: clientId,
        amount: data?.amount,
        discount: data?.discount,
        subscriber_count: data?.subscriber_count,
        supscription_frequency: data?.supscription_frequency,
      };

      const response = await axios.post(userauthregisterurl, payload);
      if (
        response?.data?.status === 201 ||
        response?.data?.status === 200 ||
        response?.data?.statusCode === 201 ||
        response?.data?.statusCode === 200
      ) {
      } else {
        return false;
      }
    } catch (error) {
      console.error("Error:", error.response?.data || error.message);
      message.error(`Error: ${error.response?.data?.message || error.message}`);
    }
  };

  const handleSubmitAddForm = async (e) => {
    const templateParams = {
      client_name: data.client_name,
      // email_id: data.email_id,
      email_id: "pushpasethuraman08@gmail.com",
      password: data?.password,
    };
    try {
      const response = await emailjs.send(
        "service_3tvmhjr", 
        "template_daebw3r", 
        templateParams,
        "y7S-zF4Gp3oh0XO4p"
      );
      if (response?.status === 200) {
        await new Promise((resolve) => {
          message.success("Email sent successfully to the user!");
          resolve();
        });
      }
    } catch (error) {
      console.log("Error:", error);
    }
  };

  console.log("data--->", data)
  const handlePostClientData = async (e) => {
    const name =
      data?.type === "personal" ? data?.client_name : data?.company_name;
    const clientId = getClientId(name);
    setLoading(true);
    // handlesubmit(clientId);
    // const url =
    //   `https://gwshc8kn48.execute-api.ap-southeast-1.amazonaws.com/Prod/addData/${userDetails?.clientId}`;
    const url =
      "https://gwshc8kn48.execute-api.ap-southeast-1.amazonaws.com/Prod/addData";
    const obj = {
      client_name: data?.client_name,
      system_name: data?.Support,
      basic_plan: !!data?.basic_plan,
      advanced_plan: !!data?.advanced_plan,
      enterprise_plan: !!data?.enterprise_plan,
      status: data?.status,
      updated_date: new Date().toLocaleDateString("en-CA"),
      created_date: new Date().toLocaleDateString("en-CA"),
      updated_by: "",
      created_by: "",
      location: data?.location,
      email_id: data?.email_id,
      employee_count: data?.employee_count,
      subscription_plan: data?.subscription_plan,
      contact_person: data?.contact_person,
      contact_number: data?.contact_number,
      company_name: data?.company_name,
      password: "",
      usermenulist: menuList,
      clientid: userDetails?.clientId,
      amount: data?.amount,
      discount: data?.discount,
      subscriber_count: data?.subscriber_count,
      supscription_frequency: data?.supscription_frequency,
      subscription_start_date: data?.subscription_start_date,
      defaultproduct: data?.defaultproduct,
      products: {
        tymeplusHrStatus: data?.system?.includes("hr") ? true : false,
        tymeplusPayStatus: data?.system?.includes("pay") ? true : false,
      },
    };
    try {
      const response = await axios.post(url, obj, {
        headers: {
          "tymeplusjwt": token
        }
      });
      if (
        response?.data?.status === 201 ||
        response?.data?.status === 200 ||
        response?.data?.statusCode === 201 ||
        response?.data?.statusCode === 200
      ) {
        setLoading(false);
        const newData = response.data.response;
        // const sortedData = response.data.response.slice().sort((a, b) => b.id - a.id);
        dispatch(setGetAllClientData([newData, ...getAllClientData]));

        // dispatch(setGetAllClientData(sortedData));
        // handleSubmitAddForm(e);
        navigate("/client");

        message.success("Client added successfully!");
      } else {
        setLoading(false);
        message.error(response.data.message);
      }
    } catch (error) {
      console.error("Error:", error.response?.data || error.message);
      setLoading(false);
      message.error(`Error: ${error.response?.data?.message || error.message}`);
    }
  };

  // const handledCheckboxChange = (checked, menu, submenu) => {
  //   if (data?.system?.includes("hr")) {
  //     setMenuList((prevMenuList) => {
  //       const updatedList = prevMenuList?.filter((item) => item.system === "hr")?.map((item) => {
  //         if (item?.id === menu) {
  //           if (submenu?.length > 0) {
  //             const updatedSubmenu = item?.subMenu?.map((subItem) => {
  //               if (subItem?.key === submenu) {
  //                 return {
  //                   ...subItem,
  //                   permission: {
  //                     create: checked,
  //                     view: checked,
  //                     delete: checked,
  //                     edit: checked,
  //                   },
  //                   access: checked,
  //                 };
  //               }
  //               return subItem;
  //             });
  //             const allSubMenuAccessFalse =
  //               updatedSubmenu?.length > 0 &&
  //               updatedSubmenu?.every((subItem) => subItem?.access === false);
  //             return {
  //               ...item,
  //               access: allSubMenuAccessFalse ? false : true,
  //               subMenu: updatedSubmenu,
  //             };
  //           } else {
  //             return {
  //               ...item,
  //               access: checked,
  //               permission: {
  //                 create: checked,
  //                 view: checked,
  //                 delete: checked,
  //                 edit: checked,
  //               },
  //             };
  //           }
  //         }

  //         return item;
  //       });
  //       return updatedList;
  //     });
  //   } else if (data?.system?.includes("pay")) {
  // setPayMenuList((prev) => {
  //   const updatedList = prev?.map((item) => {
  //     if (item?.id === menu) {
  //       if (submenu?.length > 0) {
  //         const updatedSubmenu = item?.subMenu?.map((subItem) => {
  //           if (subItem?.key === submenu) {
  //             return {
  //               ...subItem,
  //               permission: {
  //                 create: checked,
  //                 view: checked,
  //                 delete: checked,
  //                 edit: checked,
  //               },
  //               access: checked,
  //             };
  //           }
  //           return subItem;
  //         });
  //         const allSubMenuAccessFalse =
  //           updatedSubmenu?.length > 0 &&
  //           updatedSubmenu?.every((subItem) => subItem?.access === false);
  //         return {
  //           ...item,
  //           access: allSubMenuAccessFalse ? false : true,
  //           subMenu: updatedSubmenu,
  //         };
  //       } else {
  //         return {
  //           ...item,
  //           access: checked,
  //           permission: {
  //             create: checked,
  //             view: checked,
  //             delete: checked,
  //             edit: checked,
  //           },
  //         };
  //       }
  //     }

  //     return item;
  //   });
  //   return updatedList;
  // });
  // setMenuList((prevMenuList) => {
  //   const updatedList = prevMenuList?.filter((item) => item.system === "pay")?.map((item) => {
  //     if (item?.id === menu) {
  //       if (submenu?.length > 0) {
  //         const updatedSubmenu = item?.subMenu?.map((subItem) => {
  //           if (subItem?.key === submenu) {
  //             return {
  //               ...subItem,
  //               permission: {
  //                 create: checked,
  //                 view: checked,
  //                 delete: checked,
  //                 edit: checked,
  //               },
  //               access: checked,
  //             };
  //           }
  //           return subItem;
  //         });
  //         const allSubMenuAccessFalse =
  //           updatedSubmenu?.length > 0 &&
  //           updatedSubmenu?.every((subItem) => subItem?.access === false);
  //         return {
  //           ...item,
  //           access: allSubMenuAccessFalse ? false : true,
  //           subMenu: updatedSubmenu,
  //         };
  //       } else {
  //         return {
  //           ...item,
  //           access: checked,
  //           permission: {
  //             create: checked,
  //             view: checked,
  //             delete: checked,
  //             edit: checked,
  //           },
  //         };
  //       }
  //     }

  //     return item;
  //   });
  //   return updatedList;
  // });
  //   }
  // };

  // const handledCheckboxChange = (checked, menu, submenu) => {
  //   console.log("three---->", checked, menu, submenu)
  //   setMenuList((prevMenuList) => {
  //     let updatedList = [];

  //     if (data?.system?.includes("hr") && data?.system?.includes("pay")) {
  //       // If both "hr" and "pay" are present, store all menus
  //       updatedList = prevMenuList?.map((item) =>
  //         updateMenuItem(item, menu, submenu, checked)
  //       );
  //     } else if (data?.system?.includes("hr")) {
  //       // If only "hr" is present, filter and update "hr" menus
  //       updatedList = prevMenuList
  //         ?.filter((item) => item.system === "hr")
  //         ?.map((item) => updateMenuItem(item, menu, submenu, checked));
  //     } else if (data?.system?.includes("pay")) {
  //       // If only "pay" is present, filter and update "pay" menus
  //       updatedList = prevMenuList
  //         ?.filter((item) => item.system === "pay")
  //         ?.map((item) => updateMenuItem(item, menu, submenu, checked));
  //     }

  //     return updatedList;
  //   });
  // };

  const handledCheckboxChange = (checked, menuId, submenuId) => {
    setMenuList((prevMenuList) =>
      prevMenuList.map((item) => {
        if (item.id === menuId) {
          // ✅ Prevent updating state if the item is disabled
          if (
            (data.subscription_plan === "basic" && item.planType !== "Basic") ||
            (data.subscription_plan === "lite" && item.planType === "Pro")
          ) {
            return item; // 🔥 Do not update state
          }
  
          if (!submenuId) {
            return { ...item, access: checked };
          }
  
          return {
            ...item,
            subMenu: item.subMenu.map((sub) =>
              sub.id === submenuId ? { ...sub, access: checked } : sub
            ),
          };
        }
        return item;
      })
    );
  };
  
  

  
  // Helper function to update the menu item
  const updateMenuItem = (item, menu, submenu, checked) => {
    if (item?.id === menu) {
      if (submenu?.length > 0) {
        const updatedSubmenu = item?.subMenu?.map((subItem) => {
          if (subItem?.key === submenu) {
            return {
              ...subItem,
              permission: {
                create: checked,
                view: checked,
                delete: checked,
                edit: checked,
              },
              access: checked,
            };
          }
          return subItem;
        });

        const allSubMenuAccessFalse = updatedSubmenu?.every(
          (subItem) => !subItem?.access
        );
        return {
          ...item,
          access: allSubMenuAccessFalse ? false : true,
          subMenu: updatedSubmenu,
        };
      } else {
        return {
          ...item,
          access: checked,
          permission: {
            create: checked,
            view: checked,
            delete: checked,
            edit: checked,
          },
        };
      }
    }
    return item;
  };

  useEffect(() => {
    setMenuList((prevMenuList) => {
      return prevMenuList?.map((item) => {
        let allowedPlans = [];

        // Check which system(s) exist
        const hasHR = data?.system?.includes("hr");
        const hasPay = data?.system?.includes("pay");
        const plan = data?.subscription_plan?.toLowerCase();

        // Function to add allowed plans based on subscription level
        const addAllowedPlans = (systemType) => {
          if (plan === "basic") {
            allowedPlans.push("basic");
          } else if (plan === "lite") {
            allowedPlans.push("basic", "lite");
          } else if (plan === "pro") {
            allowedPlans.push("basic", "lite", "pro");
          }
        };

        // If both HR & Pay exist, update both systems
        if (hasHR && hasPay) {
          if (item.system === "hr" || item.system === "pay") {
            addAllowedPlans(item.system);
          }
        } else {
          // If only HR exists
          if (hasHR && item.system === "hr") {
            addAllowedPlans("hr");
          }
          // If only Pay exists
          if (hasPay && item.system === "pay") {
            addAllowedPlans("pay");
          }
        }

        // Check if the item's planType is allowed
        const isAllowedPlan =
          item.key !== "allapprovals"
            ? allowedPlans.includes((item?.planType || "").toLowerCase())
            : true;

        // Handle submenu permissions
        if (item?.subMenu?.length > 0) {
          const updatedSubmenu = item?.subMenu.map((subItem) => {
            const isTravelExpense = subItem?.key === "travelexpense";
            const isAllowed =
              plan === "basic" && isTravelExpense ? false : isAllowedPlan;

            return {
              ...subItem,
              access: isAllowed,
              permission: {
                create: isAllowed,
                edit: isAllowed,
                delete: isAllowed,
                view: isAllowed,
              },
            };
          });

          return {
            ...item,
            access: isAllowedPlan,
            subMenu: updatedSubmenu,
          };
        }

        // Update parent item directly if no subMenu
        return {
          ...item,
          access: isAllowedPlan,
          permission: {
            create: isAllowedPlan,
            edit: isAllowedPlan,
            delete: isAllowedPlan,
            view: isAllowedPlan,
          },
        };
      });
    });
  }, [data?.subscription_plan, data?.system, data]);

  const footerStyle = {
    position: "fixed",
    bottom: 0,
    left: "270px",
    right: 0,
    backgroundColor: "#fff",
    padding: "10px",
    display: "flex",
    justifyContent: "end",
    boxShadow: "0 2px 10px rgba(0, 0, 0, 0.1)",
    margin: "0px 0px",
  };

  const groupedData = {
    Basic: menuList?.filter(
      (item) =>
        item?.system === "hr" &&
        (item?.key === "allapprovals" || item?.planType === "Basic")
    ),
    Lite: menuList?.filter(
      (item) =>
        item?.system === "hr" &&
        (item?.key === "allapprovals" || item?.planType === "Lite")
    ),
    Pro: menuList?.filter(
      (item) =>
        item?.system === "hr" &&
        (item?.key === "allapprovals" || item?.planType === "Pro")
    ),
  };

  const groupedPayData = {
    Basic: menuList?.filter(
      (item) => item?.system === "pay" && item?.planType === "Basic" && item
    ),
    Lite: menuList?.filter(
      (item) => item?.system === "pay" && item?.planType === "Lite" && item
    ),
    Pro: menuList?.filter(
      (item) => item?.system === "pay" && item?.planType === "Pro"
    ),
  };

  const renderPlanBox = (planType, menu) => (
    <div
      style={{
        border: "1px solid #ccc",
        borderRadius: "8px",
        padding: "20px",
        marginBottom: "20px",
        backgroundColor: "#f9f9f9",
        flex: "1",
      }}
    >
      <h3 style={{ textAlign: "center", color: "#333", marginBottom: "20px" }}>
        {planType} Plan
      </h3>
      {menu.map((item) => (
        <div key={item.key} style={{ marginBottom: "10px" }}>
          {item?.subMenu?.length === 0 && (
            <>
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                }}
              >
                <span>{item?.menuName}</span>
                <Checkbox
                  name={item.name}
                  checked={item?.access}
                  // readOnly={true}
                  disabled={
                    (data.subscription_plan === "basic" && item.planType !== "Basic") || // Disable Lite & Pro if Basic is selected
                    (data.subscription_plan === "lite" && item.planType === "Pro") // Disable Pro if Lite is selected
                  }
                  style={{ width: "30px" }}
                  // onChange={(e) =>
                  //   handledCheckboxChange(e.target.checked, item.id, "")
                  // }
                  onChange={(e) => {
                    // Prevent changes when the checkbox should be read-only
                    if (
                      (data.subscription_plan === "basic" && item.planType !== "Basic") || 
                      (data.subscription_plan === "lite" && item.planType === "Pro")
                    ) {
                      return; // Do nothing, making it read-only
                    }
                    handledCheckboxChange(e.target.checked, item.id, item.key);
                  }}
                />
              </div>
            </>
          )}
          {item?.subMenu?.length > 0 && (
            <>
              {item?.subMenu
                ?.filter((val) => val?.planType === planType)
                .map((val) => (
                  <div key={val.key} style={{ marginBottom: "10px" }}>
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                      }}
                    >
                      <span>{val?.menuName}</span>
                      <Checkbox
                        name={val.name}
                        style={{ width: "30px" }}
                        checked={val?.access}
                        disabled={
                          (data.subscription_plan === "basic" && val.planType !== "Basic") || // Disable Lite & Pro if Basic is selected
                          (data.subscription_plan === "lite" && val.planType === "Pro") // Disable Pro if Lite is selected
                        }
                        // readOnly={true}
                        // onChange={(e) =>
                        //   handledCheckboxChange(
                        //     e.target.checked,
                        //     item.id,
                             
                        //   )
                        // }
                        onChange={(e) => {
                          // Prevent changes when the checkbox should be read-only
                          if (
                            (data.subscription_plan === "basic" && val.planType !== "Basic") || // Disable Lite & Pro if Basic is selected
                            (data.subscription_plan === "lite" && val.planType === "Pro") // Disable Pro 
                          ) {
                            return; // Do nothing, making it read-only
                          }
                          handledCheckboxChange(e.target.checked, val.id, val.key);
                        }}
                      />
                    </div>
                  </div>
                ))}
            </>
          )}
        </div>
      ))}
    </div>
  );

  // const renderPlanBox = (planType, menu) => (
  //   <div
  //     style={{
  //       border: "1px solid #ccc",
  //       borderRadius: "8px",
  //       padding: "20px",
  //       marginBottom: "20px",
  //       backgroundColor: "#f9f9f9",
  //       flex: "1",
  //     }}
  //   >
  //     <h3 style={{ textAlign: "center", color: "#333", marginBottom: "20px" }}>
  //       {planType} Plan
  //     </h3>
  //     {menu.map((item) => {
  //       // ✅ Fix: Set the correct disabled state for main menu
  //       const isMainMenuDisabled =
  //         (data.subscription_plan === "basic" && item.planType !== "Basic") ||
  //         (data.subscription_plan === "lite" && item.planType === "Pro");
  
  //       return (
  //         <div key={item.key} style={{ marginBottom: "10px" }}>
  //           <div
  //             style={{
  //               display: "flex",
  //               justifyContent: "space-between",
  //               alignItems: "center",
  //             }}
  //           >
  //             <span>{item?.menuName}</span>
  //             <Checkbox
  //               name={item.name}
  //               checked={item?.access}
  //               disabled={isMainMenuDisabled} // ✅ Apply correctly
  //               style={{ width: "30px", cursor: isMainMenuDisabled ? "not-allowed" : "pointer" }}
  //               onChange={(e) => {
  //                 if (isMainMenuDisabled) return; // ✅ Prevent function execution if disabled
  //                 handledCheckboxChange(e.target.checked, item.id, null);
  //               }}
  //             />
  //           </div>
  
  //           {/* ✅ Fix: Handle Submenus Properly */}
  //           {item?.subMenu?.length > 0 &&
  //             item?.subMenu.map((val) => {
  //               const isSubMenuDisabled =
  //                 (data.subscription_plan === "basic" && val.planType !== "Basic") ||
  //                 (data.subscription_plan === "lite" && val.planType === "Pro");
  
  //               return (
  //                 <div key={val.key} style={{ marginBottom: "10px" }}>
  //                   <div
  //                     style={{
  //                       display: "flex",
  //                       justifyContent: "space-between",
  //                       alignItems: "center",
  //                     }}
  //                   >
  //                     <span>{val?.menuName}</span>
  //                     <Checkbox
  //                       name={val.name}
  //                       checked={val?.access}
  //                       disabled={isSubMenuDisabled} // ✅ Apply correctly
  //                       style={{ width: "30px", cursor: isSubMenuDisabled ? "not-allowed" : "pointer" }}
  //                       onChange={(e) => {
  //                         if (isSubMenuDisabled) return; // ✅ Prevent function execution if disabled
  //                         handledCheckboxChange(e.target.checked, item.id, val.id);
  //                       }}
  //                     />
  //                   </div>
  //                 </div>
  //               );
  //             })}
  //         </div>
  //       );
  //     })}
  //   </div>
  // );
  
  
  const navigate = useNavigate();
  const [activeStep, setActiveStep] = useState(1);
  const items = [
    {
      title: "1",
      description: "",
    },
    {
      title: "2",
      description: "",
    },
  ];

  const handleChangeStep = () => {
    if (step === 1) {
      handlePostClientData();
    } else {
      setStep(step + 1); // Update activeStep with the clicked step index
    }
  };
  const handleChangePrevStep = () => {
    if (step === 0) {
      navigate("/client");
    } else {
      setActiveStep(activeStep - 1);
      setStep(step - 1);
    }
  };

  return (
    <StyledClientWrapper>
      {ispermission ? (
        <>
          <label
            className="bg-transparent border-0 mb-3 text-left styled-cursor"
            onClick={() => setIsPermission(false)}
          ></label>{" "}
          <b className="pb-0 pt-1">Select Permission</b>
          <UITable data={tabledata} columns={columns} />
          <div className="text-right w-100 p-1">
            <ButtonFilled
              className="text-end logout-button"
              // type="submit"
              htmlType="submit"
              onClick={() => setIsPermission(true)}
            >
              Create
            </ButtonFilled>
          </div>
        </>
      ) : (
        <>
          <div className="mb-4">
            <div>
              <h5 className="view_client_goback">
                <p onClick={() => navigate("/client")}>Client</p>{" "}
                <RightOutlined className="right_out_icon" />{" "}
                <storng className="!bg-[red]">Adding Client</storng>{" "}
              </h5>
            </div>
            <StepsProgress stepdata={stepdata} title="Add Role:" step={step} />
            {/* <Steps current={activeStep} labelPlacement="vertical" items={items} /> */}
            {step === 0 && (
              <>
                <GridBuilder
                  formStructureJson={addNewClientForm}
                  setStep={setStep}
                  formSubmit={handleSubmitForm}
                  handleChange={handleFormChange}
                  handleSelectChange={handleSelectChange}
                  handleBack={handleClickCancel}
                  initialValues={data}
                  ref={formRef}
                />
              </>
            )}
            <br />
            <br />

            {step === 1 && (
              <>
                {/* <Form
                  layout="vertical"
                >
                  <Form.Item
                    label="System"
                    name="system"
                    rules={[
                      {
                        required: true,
                        message: "System is required",
                      },
                    ]}
                  >
                    <Select
                      options={SystemOption}
                      showSearch={false}
                      mode="multiple"
                      onChange={(e) => handleSelectChange(e, "system")}

                    />
                  </Form.Item>
                </Form> */}
                {data?.system?.includes("hr") && (
                  <>
                    <p className="system_label">Tymeplus HR Features</p>
                    <div
                      style={{
                        display: "flex",
                        gap: "20px",
                        flexWrap: "wrap",
                        marginBottom:
                          data?.system?.includes("hr") &&
                          !data?.system?.includes("pay")
                            ? "5rem"
                            : undefined,
                      }}
                    >
                      {Object.entries(groupedData)?.map(([planType, data]) => {
                        return renderPlanBox(planType, data);
                      })}
                    </div>
                  </>
                )}

                {data?.system?.includes("pay") && (
                  <>
                    <p className="system_label">Tymeplus Pay Features</p>
                    <div
                      style={{
                        display: "flex",
                        gap: "20px",
                        marginBottom: "5rem",
                      }}
                    >
                      {Object.entries(groupedPayData)?.map(
                        ([planType, data]) => {
                          return renderPlanBox(planType, data); // Ensure return inside map
                        }
                      )}
                    </div>
                  </>
                )}

                <div
                  className="text-right form_button_section"
                  style={footerStyle}
                >
                  <ButtonOutlined
                    className={loading ? "custom-style-btn" : "logout-button"}
                    type="primary"
                    // htmlType="submit"
                    disabled={loading}
                    onClick={(e) => {
                      handleChangePrevStep();
                    }}
                  >
                    {step === 0 ? "Cancel" : "Prev"}
                  </ButtonOutlined>
                  <ButtonFilled
                    className={loading ? "custom-style-btn" : "logout-button"}
                    type="primary"
                    disabled={loading}
                    onClick={(e) => {
                      handleChangeStep();
                    }}
                  >
                    {loading ? <Spin /> : step === 1 ? "Create" : "Next"}
                  </ButtonFilled>
                </div>
              </>
            )}
          </div>
        </>
      )}
    </StyledClientWrapper>
  );
};

export default AddNewClient;
